import {useStatesGlobal} from '../../../../gori/providers'

const getPackageDetails = (package_type: string, carriersPackage) => {
  for (const pkg of carriersPackage) {
    const found = pkg.value.find((item) => item.value === package_type)
    if (found) {
      return {
        fieldsHidden: found.parcel?.hidden,
        editable: found.parcel?.editable,
        packageType: found,
      }
    }
  }
  return {
    fieldsHidden: undefined,
    editable: undefined,
    packageType: null,
  }
}

const OrderHelper = () => {
  const {statesGlobal} = useStatesGlobal()
  return {
    getPackageDetails: (package_type: string) => {
      const carriersPackage = statesGlobal.carriersPackage
      return getPackageDetails(package_type, carriersPackage)
    },
  }
}

export default OrderHelper
